import { Box, Dialog } from "@mui/material";
import { MouseEvent, useState } from "react";

// htmlImageMax is how big an image in a note is drawn at, in px. Anything larger is
// scaled down to fit and opened full size in the previewer.
export const htmlImageMax = 400;

// htmlImageSx draws the images inside a note at the size above
export const htmlImageSx = {
    "& img": { maxWidth: htmlImageMax, maxHeight: htmlImageMax, cursor: "zoom-in" },
};

// useImagePreview opens a clicked image at its full size. Hand onClick to whatever
// holds the images, and put element in the same tree.
export function useImagePreview() {
    const [src, setSrc] = useState("");

    return {
        onClick: (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (target.tagName !== "IMG") return;

            setSrc((target as HTMLImageElement).src);
        },
        element: <ImagePreview src={src} onClose={() => setSrc("")} />,
    };
}

function ImagePreview(props: { src: string; onClose: () => void }) {
    return (
        <Dialog
            open={!!props.src}
            onClose={props.onClose}
            maxWidth={false}
            slotProps={{ paper: { sx: { bgcolor: "transparent", boxShadow: "none" } } }}
        >
            <Box
                component="img"
                src={props.src}
                alt=""
                onClick={props.onClose}
                sx={{ display: "block", maxWidth: "90vw", maxHeight: "90vh", cursor: "zoom-out" }}
            />
        </Dialog>
    );
}
